import React, { useState, useContext } from 'react'
import toast from 'react-hot-toast';
import AuditLogsService from '../../../../../../../services/api/audit-logs.service';
import moment from "moment";
import { store } from '../../../../../../../context/StateProvider';
import Module from '../../../../../../templates/components/Module';
import Table2 from '../../../../../../templates/components/Table2';
import DatePicker from '../../../../../../templates/components/DatePicker';
import HPTSelect from '../../../../../../templates/components/HPTSelect';
import PatientSelector from '../../../../../../templates/components/PatientSelector';
import AuditLogsView from '../audit-logs-view/AuditLogsView';
import ModalBox from '../../../../../../templates/components/ModalBox';

const AuditLogsTable = (props) => {
  const state = useContext(store).state
  const [isLoader, setIsLoader] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("D"));
  const [endDate, setEndDate] = useState(moment().endOf("D"));
  const [selectedLog, setSelectedLog] = useState()
  const [show, setShow] = useState(false)
  const [logList, setLogList] = useState()
  const [locationId, setLocationId] = useState(state.practiceLocationId || null)
  const [keyword, setKeyword] = useState()
  const [selectedTable, setSelectedTable] = useState()
  const [initialMessage, setInitialMessage] = useState(true)

  const onPatientChange = (newPatientId) => {
    setKeyword(newPatientId)
  }

  const getAuditLogs = () => {
    setIsLoader(true)
    setInitialMessage(false);
    let reqObj = {
      StartDate: moment(startDate).toISOString(),
      EndDate: moment(endDate).toISOString(),
      SortField: 'CreatedOn',
      Asc: true
    }
    if (locationId) reqObj.PracticeLocationId = locationId;
    if (keyword) {
      reqObj.PatientId = keyword
    }
    if (selectedTable) {
      reqObj.Table = selectedTable
    }
    AuditLogsService.getAuditLogs(reqObj).then(res => {
      //console.log(JSON.stringify(res?.data?.data))
      if (res?.data?.data) {
        setLogList(res?.data?.data)
      } else {
        setLogList([])
      }
      setIsLoader(false)
    }).catch(() => {
      toast.error('Oops! Something went wrong');
      setIsLoader(false)
    });
  }
  const tableList = [
    { key: 'Appointments', value: 'Appointments' },
    { key: 'Invoice', value: 'Invoice' }
  ]
  const columns = [
    {
      id: "tableName",
      Header: "Table",
      accessor: (log) => log.tableName
    },
    {
      id: "patientId",
      Header: "Patient",
      accessor: (log) => `${log.firstName + ' ' + log.lastName}`
    },
    {
      id: "createdOn",
      Header: "Date",
      accessor: (log) => moment(log.createdOn).utc().format("MM/DD/YYYY h:mm A")
    },
    {
      id: "operation",
      Header: "Operation",
      accessor: (log) => log.operation
    },
    {
      id: "actions",
      Header: "Actions",
      textAlign: 'center',
      disableSortBy: true,
      accessor: (log) => {
        return (<div className='d-flex justify-content-center'>
          <div className='btn-group'>
            <button className='p-1 btn btn-primary' title="View" onClick={e => {
              e.preventDefault();
              setSelectedLog(log);
              return setShow(true)
            }}><i className='icon eye' /></button>
          </div>
        </div>
        )
      }
    },
  ];

  return (
    <>
      <div className="row d-flex g-3">
        <div className='col-12 px-0'>
          <Module title="Filters">
            <div className='row d-flex'>
              <div className='col-12 row d-flex justify-content-center mx-0'>
                <div className='col-md-2 col-12'>
                  <label>Table</label>
                  <HPTSelect
                    className='react-select-container'
                    classNamePrefix='react-select'
                    name="table"
                    onChange={e => setSelectedTable(e?.value)}
                    isClearable
                    placeholder="All"
                    options={tableList}
                    getOptionLabel={(option) => option.key}
                    getOptionValue={(option) => option.value}
                  >
                  </HPTSelect>
                </div>
                <div className='col-md-4 col-12'>
                  <div className='ui field'>
                    <label>Patient</label>
                    <PatientSelector onSelected={onPatientChange} showAddPatient={true}/>
                  </div>
                </div>
                <DatePicker startDate={startDate} endDate={endDate} setEndDate={setEndDate} setStartDate={setStartDate} setLocationId={setLocationId} />
                <div className="col-md-auto col-12" style={{
                  alignContent: 'end',
                  paddingBottom: '1px'
                }}>
                  <button className="btn btn-primary" onClick={e => { e.preventDefault(); getAuditLogs() }} title="Pull Audit Logs">
                    <i className="icon arrow circle right" />
                  </button>
                </div>
              </div>
            </div>
          </Module>
        </div>
        <div className='col-12 px-0'>
          <Module title="Audit Logs">
            <Table2
              export
              searchable
              loading={isLoader}
              columns={columns}
              data={logList}
              initialMessage={initialMessage}
            />
          </Module>
        </div>
      </div>
      <ModalBox open={show} onClose={() => { setShow(false) }} title="Audit Log" size="fullscreen">
        {selectedLog && <AuditLogsView auditLogId={selectedLog.id} onClose={() => { setShow(false) }} />}
      </ModalBox>
    </>

  );
};

export default AuditLogsTable;

